import Api from './Api';

const END_POINT = 'debts';

export default {

    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },
    async get_allPaginated(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}-list-paginated`, request);
    },
    amortize(payment) {
        return Api.post(`${END_POINT}/amortize`, payment);
    },

}